import { Link } from 'react-router-dom';
import type { VideoItem } from '@/types/video';
import { detailPath, typeLabel } from '@/data/videos';

interface LatestUpdatesProps {
  items: VideoItem[];
}

export default function LatestUpdates({ items }: LatestUpdatesProps) {
  if (items.length === 0) {
    return <p className="rounded-lg bg-background-50 p-6 text-center text-sm text-foreground-500">暂无内容</p>;
  }

  return (
    <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
      {items.map((item) => (
        <Link
          key={`${item.type}-${item.id}`}
          to={detailPath(item)}
          className="group flex cursor-pointer items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-accent-300"
        >
          <div className="relative h-[74px] w-[54px] shrink-0 overflow-hidden rounded-md bg-primary-900">
            <img
              src={item.cover}
              alt={`${item.title}封面`}
              title={`${item.title} - 最近更新`}
              className="absolute inset-0 h-full w-full object-cover object-top"
            />
          </div>
          <div className="min-w-0 flex-1">
            <div className="flex items-center gap-2">
              <h3 className="truncate text-sm font-medium text-foreground-950 group-hover:text-primary-600">
                {item.title}
              </h3>
              <span className="shrink-0 rounded bg-secondary-100 px-1.5 py-0.5 text-[10px] text-secondary-800">
                {typeLabel(item.type)}
              </span>
            </div>
            <p className="mt-1 truncate text-xs text-foreground-500">
              {item.genres.slice(0, 2).join(' · ')} · {item.year}
            </p>
            <p className="mt-1 flex items-center gap-1 text-[11px] text-foreground-400">
              <i className="ri-refresh-line text-xs" />
              更新于 {item.updatedAt}
              {item.type === 'tv' && item.episodeCount ? ` · 全${item.episodeCount}集` : ''}
            </p>
          </div>
          <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-background-100 text-foreground-400 transition-colors group-hover:bg-accent-500 group-hover:text-primary-950">
            <i className="ri-play-fill text-base" />
          </span>
        </Link>
      ))}
    </div>
  );
}